module.exports = __webpack_public_path__ + "static/media/redaction-image.4fc1557f.png";